/*eslint-disable max-len*/

import React from 'react';
import { Container, Flex, Image, Li, Link, MarginBox, Ol, Paragraph, Section, SectionHeader, Text, Ul } from 'UI';

export const TermsAndConditionsES = () => {
  return (
    <Container size={'md'} alignText={'justify'}>
      <Flex direction={'column'}>
        <MarginBox mt={15} />
        <Flex justify={'center'}>
          <Text type={'h5_bold'}>CONDICIONES GENERALES DE USO</Text>
        </Flex>
        <MarginBox mt={30} />
        <Section>
          <Paragraph>
            Las presentes Condiciones Generales de Uso (en adelante &quot;Condiciones Generales&quot;) regulan el acceso
            y la utilización del servicio RPARTSTORE que ofrece Renault, SAS, sociedad con un capital de 533.941.113
            euros, con domicilio social en 122-122 bis Avenue du Général Leclerc - 92100 Boulogne-Billancourt, inscrita
            en el Registro Mercantil de Nanterre con el número 780 129 987 y RENAULT ESPAÑA COMERCIAL SA, con domicilio
            en Avda. Europa 1, 28108 Alcobendas, Madrid y con NIF A47329180 (en adelante &quot;RENAULT&quot;)
          </Paragraph>
          <Paragraph>
            <SectionHeader
              title={
                'EL USUARIO DEBE LEER ATENTAMENTE ESTAS CONDICIONES GENERALES ANTES DE ACEPTARLAS Y ACCEDER A LOS SERVICIOS.'
              }
              underline
            />
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 1'} title={'Designación de la Plataforma'} />
          <Paragraph>
            El sitio web RPARTSTORE (en adelante, &quot;la <b>Plataforma</b>&quot;), ha sido creado para facilitar el
            contacto entre vendedores (en adelante, los &quot;<b>Vendedores</b>&quot;) que deseen ofrecer repuestos y
            accesorios (en adelante, los &quot;<b>Productos</b>&quot;) para la venta a través de un sitio web a
            compradores (en adelante, los &quot;<b>Compradores</b>&quot;), de acuerdo con las presentes condiciones
            generales de uso (en adelante, las &quot;<b>Condiciones Generales</b>&quot;).
          </Paragraph>
          <Paragraph>
            Se puede acceder a los servicios de la Plataforma en la siguiente dirección de correo electrónico:{' '}
            <Link to={'https://rpartstore.renault.com'} external newTab>
              https://rpartstore.renault.com
            </Link>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 2'} title={'Naturaleza del alojamiento'} />
          <Paragraph>
            La Plataforma actúa como intermediario técnico. Ofrece a Vendedores y Compradores (&quot;<b>Usuarios</b>
            &quot;) servicios técnicos de almacenamiento y transporte de datos en el sentido previsto en la normativa.
          </Paragraph>
          <Paragraph>
            La función de la Plataforma es puramente técnica y se limita a facilitar el contacto entre Vendedores y
            Compradores.
          </Paragraph>
          <Paragraph>
            La Plataforma no asume ninguna responsabilidad ni da ninguna garantía con respecto a ningún acuerdo,
            intercambio, oferta o comunicación en general que puedan tener lugar a través de ella.
          </Paragraph>
          <Paragraph>
            La Plataforma no es en modo alguno un vendedor o un revendedor de los Productos ofrecidos por los Vendedores
            a través de la Plataforma.
          </Paragraph>
          <Paragraph>
            Las operaciones relacionadas con los Productos ofrecidos por los Vendedores se realizan siempre directamente
            entre Vendedores y Compradores, fuera de la Plataforma. El Vendedor puede simplemente generar contactos
            comerciales (<i>formulario de contacto</i>) a través de la Plataforma. El precio final de los Productos lo
            da el Vendedor fuera de la Plataforma.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 3'} title={'Finalidad de las Condiciones Generale'} />
          <Paragraph>
            La finalidad de las presentes Condiciones Generales es establecer las condiciones para el acceso y el uso de
            la Plataforma por parte de los Usuarios.
          </Paragraph>
          <Paragraph>
            Asimismo, tiene como finalidad crear una relación digital directa entre Vendedores y Compradores con el fin
            de generar contactos comerciales entre ellos.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 4'} title={'Condiciones de acceso a la Plataforma para Compradores'} />
          <Paragraph>
            El acceso a la Plataforma implica:
            <Ul>
              <Li>
                <Text type={'text'}>
                  Que los Vendedores soliciten a los Compradores que se unan a través del minisitio de suscripción.
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>Que los Vendedores validen el acceso de los Compradores a la Plataforma.</Text>
              </Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            El minisitio de Suscripción es una aplicación de comercio electrónico que permite a los Vendedores solicitar
            a sus clientes Compradores que se suscriban a RPARTSTORE. Se puede acceder a la aplicación desde RENAULTNET
            y RPARTSTORE.
          </Paragraph>
          <Paragraph>
            El acceso al minisitio de suscripción se concede a través del centro de llamadas en el siguiente número: +34
            902877553 al Vendedor que lo solicite, siempre que tenga referencia individual en la red Renault.
          </Paragraph>
          <Paragraph>
            El minisitio de suscripción acelera el proceso de suscripción y también permite a los Vendedores realizar
            solicitudes de suscripción para sus clientes, independientemente de la naturaleza del usuario en TRESOR y
            RPARTSTORE (cliente desconocido en TRESOR, nueva suscripción, nuevo usuario).
          </Paragraph>
          <Paragraph>
            El Vendedor podrá realizar solicitudes de suscripción para sus clientes de conformidad con lo dispuesto en
            la presente cláusula. Si el cliente no está identificado en la base de datos de TRESOR, se enviará
            automáticamente una solicitud de creación/modificación al administrador de TRESOR correspondiente.
          </Paragraph>
          <Paragraph>
            El Vendedor puede modificar los datos del cliente y controlar el progreso de sus solicitudes de suscripción.
            No puede modificar una solicitud en curso, pero puede pedir que se cierre. El centro de llamadas se
            encargará en ese caso del cierre definitivo.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 5'} title={'Productos admitidos en la Plataforma'} />
          <Paragraph>
            La Plataforma selecciona los tipos de productos que se pueden encargar a través de ella. Los Compradores no
            podrán solicitar a los Vendedores que ofrezcan, a través de la Plataforma, productos distintos a los
            previamente seleccionados por la Plataforma.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 6'} title={'Clasificación'} />
          <Paragraph>
            La visualización de ofertas no está sujeta a ningún criterio de clasificación previamente determinado. El
            Comprador solo podrá elegir los criterios para clasificar por orden ascendente o descendente de precio y se
            establecerá el orden que corresponda.
          </Paragraph>
          <Paragraph>
            Respecto a la visualización de la oferta, RENAULT podrá determinar un orden de clasificación por defecto
            basándose en una de las siguientes opciones:
            <Ul>
              <Li>
                Antigüedad
                <Ul type={'circle'}>
                  <Li>De la más antigua a la más reciente</Li>
                  <Li>De la más reciente a la más antigua</Li>
                </Ul>
              </Li>
              <Li>Precio: En orden creciente</Li>
              <Li>
                Relevancia:
                <Ul type={'circle'}>
                  <Li>Aleatorio</Li>
                  <Li>Marcas</Li>
                  <Li>Características técnicas</Li>
                </Ul>
              </Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            RENAULT se reserva el derecho de modificar en cualquier momento la opción de clasificación seleccionada. El
            Comprador podrá cambiar esta clasificación por defecto utilizando una de las siguientes opciones:
            <Ul>
              <Li>Precios en orden ascendente</Li>
              <Li>Precios en orden descendente</Li>
              <Li>Antigüedad en orden ascendente: o De la más reciente a la más antigua</Li>
              <Li>Antigüedad en orden descendente: o De la más antigua a la más reciente</Li>
              <Li>Plazo de entrega en orden ascendente</Li>
              <Li>Proximidad (visible cuando los Usuarios buscan por ubicación)</Li>
              <Li>Relevancia:</Li>
              <Ul type={'circle'}>
                <Li>
                  <Text type={'text'}>Aleatorio</Text>
                </Li>
                <Li>
                  <Text type={'text'}>Marcas</Text>
                </Li>
              </Ul>
            </Ul>
          </Paragraph>
        </Section>

        <Section>
          <SectionHeader
            article={'Cláusula 7'}
            title={'Creación de un espacio para Compradores - Confidencialidad de identificadores y contraseñas'}
          />
          <Paragraph>
            <Text type={'text'} decoration={'underline'}>
              Etapas:
            </Text>
            <Ul type={'decimal'}>
              <Li>
                Recepción de un correo electrónico del Vendedor confirmando que se ha admitido a tramitación la
                solicitud. El correo electrónico también indicará el tiempo necesario para la tramitación de la
                solicitud, que variará entre 24 y 72 horas;
              </Li>
              <Li>
                Comprador recibirá por correo electrónico la información necesaria (ID / Contraseña) para conectarse a
                RPARTSTORE;
              </Li>
              <Li>
                El Vendedor también recibirá un mensaje informándole de que su cliente ya tiene acceso a RPARTSTORE;
              </Li>
              <Li>
                En caso de que la solicitud sufra alguna incidencia técnica, se notificará al Vendedor mediante correo
                electrónico.
              </Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            El uso del Área de Compradores está estrictamente limitado al usuario que designe el Vendedor.
          </Paragraph>
          <Paragraph>
            El Comprador se compromete a mantener sus claves en secreto y a no divulgarlas de ninguna forma ni a ninguna
            persona y, en caso de uso fraudulento o no autorizado, a cancelarlas y comunicar los hechos sin demora al
            departamento de servicio de atención al cliente en el número +34 902877553. Se informa al Comprador de que
            cualquier comunicación de sus claves a un tercero será bajo su exclusiva responsabilidad.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 8'} title={'Relación personalizada'} />
          <Paragraph>
            Los Compradores no podrán establecer contacto con todos los Vendedores admitidos en la Plataforma.
          </Paragraph>
          <Paragraph>
            En la Plataforma, el Comprador encontrará al Vendedor correspondiente al canal físico habitual; las opciones
            del Comprador no cambiarán.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 9'} title={'Pago'} />
          <Paragraph>
            Se entiende que, a través de la Plataforma, solo se podrán realizar contactos comerciales, y que no se
            realizará ningún pago a través de la Plataforma.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 10'} title={'Disponibilidad de los servicios de la Plataforma'} />
          <Paragraph>
            Dentro de los límites establecidos por las leyes y normativas aplicables, RENAULT declina toda
            responsabilidad por el uso de la Plataforma por parte del Usuario y no ofrece ninguna garantía, expresa o
            implícita, en cuanto a la velocidad y/o el rendimiento de la Plataforma o en cuanto al uso que realice el
            Comprador de los datos y/o la información accesibles a través de la Plataforma.
          </Paragraph>
          <Paragraph>
            En particular, RENAULT no garantiza que la Plataforma esté libre de errores, defectos u omisiones, ni que no
            sea objeto de daños o ataques, en particular de virus, que puedan provocar un mal funcionamiento,
            interrupciones del servicio, averías o pérdidas de datos o información.
          </Paragraph>
          <Paragraph>
            El acceso a la Plataforma podrá quedar suspendido temporalmente y de forma periódica por causas técnicas,
            que los equipos técnicos intentarán solucionar a la mayor brevedad posible.
          </Paragraph>
          <Paragraph>
            RENAULT quedará exonerada de toda responsabilidad:
            <Ol type={'i'}>
              <Li>
                <Text type={'text'}>
                  En caso de incumplimiento por parte del Usuario de lo estipulado en las presentes Condiciones
                  Generales de Uso;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  En caso de mal funcionamiento de la Plataforma por una causa voluntaria o involuntaria atribuible al
                  Usuario o a un tercero, o como resultado de un acto malicioso o del mal funcionamiento del software,
                  smartphones, tabletas, ordenadores o cualquier otra interfaz/producto perteneciente al Usuario;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>En caso de cambios legislativos o regulatorios que afecten a la Plataforma.</Text>
              </Li>
            </Ol>
          </Paragraph>
          <Paragraph>
            Además, el Usuario reconoce que pueden proporcionar el acceso a la Plataforma redes de comunicación, y que
            RENAULT no se hará responsable en ningún caso por el mal funcionamiento de dichas redes de comunicación.
          </Paragraph>
          <Paragraph>
            Cuando los Usuarios utilizan la Plataforma, se comprometen a hacerlo de conformidad con las presentes
            Condiciones Generales y en cumplimiento de la normativa aplicable.
          </Paragraph>
          <Paragraph>
            El Comprador y el Vendedor se hacen totalmente responsables del uso de la Plataforma y de cualquier uso de
            los datos/información recibidos a través de la Plataforma, aun cuando no sean la persona que utilice estos
            datos/información.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 11'} title={'Uso no perjudicial de la Plataforma'} />
          <Paragraph>
            El Comprador deberá abstenerse en toda circunstancia de desarrollar cualquier actividad que pueda perjudicar
            al funcionamiento de la Plataforma, dañar su reputación, la reputación de los servicios que presta y la
            reputación y las actividades de Renault Group.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 12'} title={'Intuitu personae'} />
          <Paragraph>
            La Plataforma, creada por Renault Group, contribuye a la imagen, la reputación y la notoriedad de Renault
            Group. Por tanto, la relación entre la Plataforma y sus Usuarios se basa en el principio de intuitu personae
            (en atención a la persona).
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 13'} title={'Retirada, bloqueo o exclusión de la Plataforma'} />
          <Text type="base" bold decoration={'underline'}>
            Retirada
          </Text>
          <MarginBox mt={5} />
          <Paragraph>
            Un Comprador podrá en cualquier momento notificar a la Plataforma a través de su R1 su decisión de dejar de
            utilizar sus servicios.
          </Paragraph>
          <Paragraph>
            El Comprador deberá seguir cumpliendo las obligaciones que haya contraído con los Vendedores antes de la
            fecha de finalización de su participación en la Plataforma.
          </Paragraph>
          <Text type="base" bold decoration={'underline'}>
            Bloqueo
          </Text>
          <MarginBox mt={5} />
          <Paragraph>
            La Plataforma podrá tomar las medidas adecuadas y proporcionadas que considere necesarias, consistentes en
            restringir, rebajar o suspender el acceso (en adelante, &quot;las Medidas de Restricción&quot;) total o
            parcialmente la información/elementos subidos a la Plataforma por el Concesionario, previa notificación con
            suficiente antelación o, como máximo, el día de la aplicación de la Medida de Restricción que haya decidido
            adoptar por los siguientes motivos:
            <Ol type={'i'}>
              <Li>
                <Text type={'text'}>
                  presunción grave de comportamiento indebido causante de un daño o que constituya infracción de la
                  Plataforma, las presentes Condiciones Generales, la legislación vigente o la imagen y reputación de
                  Renault Group;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>uso del Área de Compradores por personas que no sean un Comprador;</Text>
              </Li>
              <Li>
                <Text type={'text'}>negligencia o incumplimiento del deber de confidencialidad;</Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  conocimiento por parte de la Plataforma de la existencia de contenidos ilícitos o presuntamente
                  ilícitos, en particular tras la recepción de una notificación o una orden judicial para actuar contra
                  contenidos ilícitos emitida por una autoridad competente.
                </Text>
              </Li>
            </Ol>
          </Paragraph>
          <Paragraph>
            La duración de la Medida de Restricción será proporcional a los hechos denunciados, sin que pueda exceder de
            un periodo de seis (6) meses.
          </Paragraph>
          <Paragraph>
            Podrá impugnarse la Medida de Restricción adoptada por la Plataforma a través del sistema interno de
            reclamaciones. Si el Comprador no pudiera subsanar los hechos denunciados, la Plataforma podrá excluirlo
            permanentemente en las condiciones que se establecen a continuación.
          </Paragraph>
          <Text type="base" bold decoration={'underline'}>
            Exclusión
          </Text>
          <MarginBox mt={5} />
          <Paragraph>
            La Plataforma podrá excluir de forma permanente a un Comprador en caso de que:
            <Ol type={'i'}>
              <Li>
                <Text type={'text'}>abandone la red Renault por el motivo que sea;</Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  muestre cualquiera de las conductas contempladas en el punto b - 1) de esta cláusula. La Plataforma
                  podrá elegir entre bloqueo y exclusión inmediata;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  incurra en falsedad, en cualquier grado, ya que la falsedad constituye un abuso de confianza;
                </Text>
              </Li>
              <Li>
                <Text type={'text'}>reitere la conducta a que se refieren los puntos b- 2) a 4) anteriores;</Text>
              </Li>
              <Li>
                <Text type={'text'}>reciba quejas repetidas de los Vendedores;</Text>
              </Li>
              <Li>
                <Text type={'text'}>
                  tenga lugar cualquier cambio en la situación personal del Comprador que pueda afectar al principio de
                  intuitu personae (en particular: tenga lugar un cambio de control directo o indirecto, un cambio
                  significativo en la producción o las certificaciones o una declaración de concurso de acuerdo con las
                  leyes vigentes).
                </Text>
              </Li>
            </Ol>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 14'} title={'Operaciones comerciales - Secreto comercial'} />
          <Paragraph>
            La Plataforma no podrá permitir de ninguna manera que terceros (competidores, asociados, socios, etc.)
            tengan conocimiento de los intercambios, las negociaciones, los contratos y los acuerdos que se formalicen o
            celebren a través de la Plataforma. La Plataforma respetará en todo momento su programa de confidencialidad.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 15'} title={'Promociones y publicidad'} />
          <Paragraph>
            El Comprador se compromete a no utilizar la Plataforma directa o indirectamente para promocionar directa o
            indirectamente, de ninguna manera, sus productos o servicios, o los de cualquier otra persona.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 16'} title={'Ofertas en competencia. Sin exclusividad'} />
          <Paragraph>
            La suscripción a la Plataforma no crea ninguna obligación de utilizarla por parte de los Compradores.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 17'} title={'Modificación de las Condiciones Generales'} />
          <Paragraph>
            La Plataforma se reserva el derecho de modificar las Condiciones Generales. Cualquier modificación entrará
            en vigor en la fecha que se indique en la notificación enviada a los Compradores a sus respectivos espacios.
          </Paragraph>
          <Paragraph>
            Las modificaciones no se aplicarán a las operaciones que se encuentren en curso en la fecha de su entrada en
            vigor.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 18'} title={'Uso de datos personales recogidos por la Plataforma'} />
          <Paragraph>
            Con respecto al uso de la Plataforma, RENAULT tratará sus datos personales de acuerdo con la Política de
            Privacidad, que puede consultarse en el siguiente enlace:{' '}
            <Link to={'https://rpartstore.renault.com/personal-data/es'} external newTab>
              https://rpartstore.renault.com/personal-data/es
            </Link>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 19'} title={'Fuerza mayor'} />
          <Paragraph>
            Cualquier evento que tenga las características de fuerza mayor definidas por la normativa aplicable y la
            jurisprudencia y que tenga consecuencias sobre las obligaciones contractuales de cualquiera de las Partes no
            dará lugar a responsabilidad.
          </Paragraph>
          <Paragraph>
            Las Partes acuerdan considerar expresamente como casos de fuerza mayor, en particular, los fallos de
            suministro eléctrico o de la red de Internet o el mal funcionamiento informático (como &quot;gusanos&quot;,
            virus, malware, intrusiones) que tengan consecuencias sobre el funcionamiento de la Plataforma.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 20'} title={'Confidencialidad y valor probatorio'} />
          <Paragraph>
            La Plataforma utiliza medios técnicos adecuados para garantizar la confidencialidad de la información y los
            datos transmitidos a través de ella, o de las ventas o negociaciones realizadas a través de ella, con el fin
            de evitar cualquier divulgación a terceros.
          </Paragraph>
          <Paragraph>
            No obstante, estos datos se considerarán prueba válida y admisible entre Concesionarios y Clientes, así como
            entre estos últimos y la Plataforma.
          </Paragraph>
          <Paragraph>Estos datos serán almacenados de conformidad con las disposiciones legales.</Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 21'} title={'Propiedad intelectual e industrial'} />
          <Paragraph>
            Todos los elementos que integran la Plataforma (tales como textos, logotipos, imágenes, elementos gráficos o
            sonoros, software, maquetación, bases de datos, código fuente, etc.) así como razones sociales, marcas,
            diseños y signos distintivos (en adelante, el “Contenido”) están protegidos por derechos de propiedad
            intelectual e industrial. El Contenido es propiedad exclusiva de RENAULT y/o de terceros que han autorizado
            su uso.
          </Paragraph>
          <Paragraph>
            Los Usuarios disfrutan de una licencia simple, limitada, no exclusiva, intransferible, no susceptible de
            sublicencia y revocable para el uso del Contenido en el estricto contexto de la utilización de la Plataforma
            tal como se describe en este documento. Cualquier otro uso, total o parcial, del Contenido, en particular la
            reproducción, representación, adaptación, modificación, descompilación mediante cualquier proceso y en
            cualquier soporte, incluida la unión con otros programas informáticos, sin el permiso previo por escrito de
            RENAULT, está estrictamente prohibido y constituye una infracción.
          </Paragraph>
          <Paragraph>
            Los Usuarios se comprometen a informar a RENAULT a la mayor brevedad en cuanto tengan conocimiento de
            cualquier acto realizado que contravenga lo dispuesto en esta cláusula.
          </Paragraph>
          <Paragraph>
            En el estricto marco del uso de la Plataforma, los Usuarios están autorizados a utilizar las marcas y los
            derechos de propiedad intelectual e industrial de los que sean titulares o de los que hayan adquirido
            legalmente los derechos, así como su nombre comercial o denominación social. El Usuario garantiza que
            dispone de los derechos que permiten a RENAULT reproducir en la Plataforma los elementos facilitados por el
            Usuario. A este respecto, el Usuario garantiza que liberará a RENAULT de responsabilidad frente a cualquier
            reclamación, demanda, acción o procedimiento que plantee cualquier tercero en relación con el uso de dichos
            elementos y que asumirá todos los costes y daños que pudieran derivarse de ello, en particular, como
            resultado de una decisión judicial, incluso no definitiva, o un acuerdo transaccional.
          </Paragraph>
          <Paragraph>
            El Usuario está autorizado a mencionar en sus documentos comerciales su condición de Usuario referenciado
            por la Plataforma.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 22'} title={'Responsabilidad'} />
          <Paragraph>
            El Vendedor reconoce que RENAULT, en su calidad de proveedor de alojamiento, no es parte en ningún acuerdo
            y/o contrato celebrado entre el Concesionario y el Cliente, tras la publicación de los repuestos y
            accesorios en la Plataforma.
          </Paragraph>
          <Paragraph>
            El Vendedor es el único responsable de la presentación o descripción de los repuestos y accesorios que
            ofrece, de la visualización de sus precios y de cualquier comunicación y publicidad que realice; en
            consecuencia, la Plataforma no se hace responsable de los errores u omisiones cometidos por el Vendedor en
            la descripción de los repuestos y accesorios y/o en la indicación de los precios que se publican en la
            Plataforma.
          </Paragraph>
          <Paragraph>
            El Vendedor es el único responsable de la correcta aplicación de las disposiciones de la legislación
            aplicable y, en particular, de la negociación, celebración y ejecución de contratos relacionados con
            repuestos y accesorios ofrecidos en línea en la Plataforma y de la gestión de cualquier queja, recurso o
            conflicto que el Comprador pueda iniciar contra él, especialmente en caso de impago.
          </Paragraph>
          <Paragraph>
            En términos más generales, el Vendedor será el único responsable frente a los Compradores y terceros en su
            calidad de Vendedor y garantiza que liberará a RENAULT de responsabilidad a este respecto y que asumirá
            todos los costes y daños que pudieran derivarse de ello, en particular, como resultado de una decisión
            judicial, incluso no definitiva, o un acuerdo transaccional.
          </Paragraph>
          <Paragraph>
            En el caso de que un Comprador, o cualquier otra persona, emprenda acciones judiciales contra la Plataforma
            por hechos relacionados con la actividad del Vendedor, este último se compromete a liberar a la Plataforma
            de toda responsabilidad que pudiera derivarse de una sentencia.
          </Paragraph>
          <Paragraph>El Vendedor también será el único responsable del uso de su Área de Vendedor.</Paragraph>
          <Paragraph>
            El Comprador es el único responsable del pedido que realice de los productos y accesorios que se ofrezcan en
            venta en la Plataforma. También será el único responsable del uso de su Área de Comprador y de la
            información que proporcione a los Vendedores.
          </Paragraph>
          <Paragraph>
            De manera más general, es el único responsable como Comprador y no se podrá exigir responsabilidad a la
            Plataforma en calidad de Comprador.
          </Paragraph>
          <Paragraph>
            En el caso de que un Vendedor, o cualquier otra persona, emprenda acciones judiciales contra la Plataforma
            por hechos relacionados con la actividad del Comprador, el Vendedor se compromete a liberar a la Plataforma
            de toda responsabilidad que pudiera derivarse de una sentencia.
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 23'} title={'Reclamaciones - Notificación'} />
          <Paragraph type={'text_bold'}>
            <i>a) Sistema interno de reclamaciones</i>
          </Paragraph>
          <Paragraph align={'start'}>
            La Plataforma ha establecido un sistema interno de reclamaciones relativas a las cuestiones siguientes:
            <Ul>
              <Li>
                El presunto incumplimiento por parte de la Plataforma relacionado con la prestación de servicios de
                intermediación en línea que afecte al Usuario reclamante;
              </Li>
              <Li>
                Cuestiones tecnológicas directamente relacionadas con la prestación de servicios de intermediación y que
                afecten al Usuario reclamante;
              </Li>
              <Li>
                Medidas Restrictivas adoptadas por la Plataforma o su comportamiento directamente relacionado con la
                prestación de servicios de intermediación en línea que afecte al Usuario reclamante.
              </Li>
            </Ul>
          </Paragraph>
          <Paragraph>
            En relación con las Medidas Restrictivas adoptadas por la Plataforma después de su notificación o por
            considerar que la información/los elementos proporcionados por el Usuario son ilícitos o incompatibles con
            las Condiciones Generales, el Usuario tendrá un periodo de seis meses para presentar una reclamación después
            de la notificación de dicha Medida.
          </Paragraph>
          <Paragraph>
            La Plataforma se compromete a atender las reclamaciones en un plazo acorde a la complejidad e importancia
            del problema planteado y a enviar una respuesta al Usuario que presenta la reclamación.
          </Paragraph>
          <Paragraph type={'text_bold'}>
            <i>b) Notificación</i>
          </Paragraph>
          <Paragraph>
            <Text type={'text'}>
              El Usuario podrá enviar cualquier notificación precisa y fundamentada por medios electrónicos en la que
              indique la presencia en la Plataforma de contenidos que considere ilícitos. Estas notificaciones serán
              verificadas por la Plataforma, que se reserva el derecho de decidir si acepta o no esta calificación y de
              tomar las Medidas Restrictivas pertinentes. La decisión que adopte la Plataforma será comunicada al
              denunciante, si se hubiera identificado, y podrá ser recurrida, en particular a través del sistema interno
              de reclamaciones. Si, por razones técnicas u operativas, la Plataforma no pudiera tomar medidas directas,
              informará al denunciante.
            </Text>
          </Paragraph>
          <Paragraph>
            Las comunicaciones deben dirigirse a este único punto de contacto:{' '}
            <Link to={'mailto:dpo@renault.com'} external newTab>
              dpo@renault.com
            </Link>
          </Paragraph>
        </Section>
        <Section>
          <SectionHeader article={'Cláusula 24'} title={'Ley aplicable - Controversias'} />
          <Paragraph>Las presentes Condiciones Generales se regirán por la legislación española.</Paragraph>
          <Paragraph>
            En caso de conflicto relacionado con las presentes Condiciones Generales, las partes tratarán primero de
            resolverlo amistosamente antes de someterlo a los tribunales de la ciudad de Madrid capital, a los que las
            partes confieren jurisdicción exclusiva, aun en el caso de pluralidad de demandados o de acciones
            indemnizatorias interpuestas por terceros.
          </Paragraph>
        </Section>
        <MarginBox mt={60} />
        <SectionHeader title={'ANEXO I'} underline />
        <SectionHeader
          title={'INFORMACIÓN DE COMPRADORES - PROCEDIMIENTO DE ACCESO (ADÁPTESE A CADA PAÍS)'}
          underline
        />
        <MarginBox mt={30} />
        <Image src={'terms-and-conditions/terms-and-conditions-ES.png'} alt={'information-diagram-spain'} />
        <MarginBox mt={90} />
      </Flex>
    </Container>
  );
};
